<script>
  import TimeBarChart from "./TimeBarChart.svelte";
  import DoubleAxisLineChart from "./DoubleAxisLineChart.svelte";
  export let data;

  export let lastUpdate;

  let hasRecent = false;
  let hasOverall = false;

  function exists(value) {
    return value !== undefined && value !== null && value !== 0;
  }

  $: {
    if (lastUpdate) lastUpdate.getTime(); // HACK
    if (!!data && !!data.store) {
      hasRecent = exists(data.recent);
      hasOverall = exists(data.overall);
    }
  }
</script>

<article class="app-charts">
  {#if !!data && !!data.store}
    <TimeBarChart
      title={'Discussions (new & deleted reviews total)'}
      data={data.discussions} />
    {#if hasRecent}
      <DoubleAxisLineChart title={'Recent'} data={data.recent} />
    {/if}
    {#if hasOverall}
      <DoubleAxisLineChart title={'Overall'} data={data.overall} />
    {/if}
    <DoubleAxisLineChart title={'Ratings'} data={data.ratings} />
    <DoubleAxisLineChart title={'Purchases'} data={data.purchases} />
  {/if}
</article>
